<div class="host-edit-rate">
  <div class="v4-layout-form">
    <div class="v4-layout-field" *ngIf="pageType === 'rate'">
      <span class="v4-layout-field-label w-[80px]">{{ "edit_rate.control.label.score" | translate }}</span>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <nz-rate [(ngModel)]="score"></nz-rate>
        </div>
      </div>
    </div>
    <div class="v4-layout-field">
      <span class="v4-layout-field-label w-[80px]">{{ "edit_rate.control.label.content" | translate }} </span>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <textarea
            nz-input
            rows="4"
            [placeholder]="
              (pageType === 'rate' ? 'edit_rate.control.placeholder.rate' : 'edit_rate.control.placeholder.reply')
                | translate
            "
            [(ngModel)]="content"
          ></textarea>
        </div>
        <div class="v4-layout-field-extra">
          <div class="w-[180px]">
            <host-rate-tpl-picker (onSelect)="onSelectQuickRate($event)"></host-rate-tpl-picker>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="footer flex flex-row items-center justify-between">
    <div class="ml-auto">
      <button class="mr-3" nzSize="large" nz-button (click)="onCancel()">{{ "word.cancel" | translate }}</button>
      <button nzSize="large" nz-button nzType="primary" (click)="onSave()">{{ "word.save" | translate }}</button>
    </div>
  </div>
</div>
